import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, map, countBy, identity, sum, keyBy, values, pickBy } from 'lodash/fp'
import { moment } from 'features/Moment'
import { unitOfTime } from 'moment'
import { merge, orderBy } from 'lodash'
import { createKeyObject } from '../../utils'
import { GraphStackedBar } from '../../GraphStackedBar'
import { ICall } from 'features/CallAnalytics/types'

const pickByBetween = (data, start, end) =>
  flow(
    pickBy((val, key) => {
      const keyNum = parseInt(key, 10)
      return keyNum >= start && keyNum < end
    }),
    values,
    sum
  )(data)

const formatData = (data: ICall[], sumPeriod: unitOfTime.StartOf) =>
  flow<ICall[], any, any, any>(
    map((call: ICall) => ({
      ...call,
      dateTime: moment(call.dateTime)
        .local()
        .startOf(sumPeriod)
        .format(),
    })),
    groupBy('dateTime'),
    map((items: ICall[]) => {
      const callsByCaller = flow<ICall[], any, any, any>(
        map('incomingCaller'),
        countBy(identity),
        values
      )(items)
      const numCallers = Object.keys(callsByCaller).length
      const callsByCallerFreqency = countBy(identity, callsByCaller)
      const getPercent = val => ((val || 0) / numCallers) * 100
      return {
        date: items[0].dateTime,
        1: getPercent(callsByCallerFreqency[1]) || 0,
        2: getPercent(callsByCallerFreqency[2]) || 0,
        3: getPercent(callsByCallerFreqency[3]) || 0,
        4: getPercent(callsByCallerFreqency[4]) || 0,
        '5+': getPercent(pickByBetween(callsByCallerFreqency, 5, 10)) || 0,
        '10+': getPercent(pickByBetween(callsByCallerFreqency, 10, Infinity)) || 0,
      }
    })
  )(data)

const formatBaseData = (data, keys) =>
  flow(
    map(date => ({ date, ...createKeyObject(keys) })),
    keyBy('date')
  )(data)

const keys = ['1', '2', '3', '4', '5+', '10+']

export const CallsRepeatCallers = ({
  calls,
  dateInterval,
  sumPeriod,
  dateFormat,
  loading,
  height,
}) => {
  const baseData = formatBaseData(dateInterval, keys)
  const rawData = formatData(calls, sumPeriod)
  const data = orderBy(values(merge(baseData, rawData)), 'date')

  return (
    <InfoCard
      style={{ height: '100%' }}
      title="Number of calls each caller makes"
      loading={loading}
      allowOverflow
    >
      <ParentSize>
        {({ width }) => (
          <GraphStackedBar
            width={width}
            height={height}
            data={data}
            keys={keys}
            label="Number of calls"
            dateFormat={dateFormat}
          />
        )}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsRepeatCallers/CallsRepeatCallers.tsx